function init() {
  // This is the launch_date = product.metafields.custom.launch_date needs to be assigned on products
  // TODO need to rename and recreate global Metafield object and
  // create the naming convention of this metafield in both files or it will break
  // Now using global metafield for date // count_down_ribben.launch_date | date: "%Y-%m-%d %H:%M"
  const countdownDateString = window.countdownTimerRibbon.data.launchDate;

  const countdownDate = new Date(countdownDateString.replace(/-/g, '/'));

  const countdownDateTime = countdownDate.getTime();
  if (!countdownDateTime) {
    // PDP has metafield for Launch Date
    // This has been updated for global launch date metafield in count-down-timer-ribber.js
    console.error('countdown-timer-ribbon: Invalid Launch Date ');
    return;
  }

  const { data, alpineData } = window.countdownTimerRibbon;

  // define date components in reactive object
  const { dateComponents } = alpineData.reactiveState;

  // calculate difference from today
  const updateReactiveDateComponents = (clearIntervalCallback) => {
    const difference = countdownDateTime - Date.now();

    // if time remaining is less than 1 second, stop interval and set everything to zero
    if (difference < 1000) {
      dateComponents.days = alpineData.defaultState.days;
      dateComponents.hours = alpineData.defaultState.hours;
      dateComponents.minutes = alpineData.defaultState.minutes;
      dateComponents.seconds = alpineData.defaultState.seconds;
      dateComponents.open = alpineData.open;

      /* if less than 1 second hide bar this works */
      /* I am forcing this to be false if it's a second to hide the bar */
      dateComponents.open = false;
      document.querySelector('.countdown-ribbon-timmer').style.display = 'none';

      clearIntervalCallback();
      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    dateComponents.days = String(days).padStart(2, '0');
    dateComponents.hours = String(hours).padStart(2, '0');
    dateComponents.minutes = String(minutes).padStart(2, '0');
    dateComponents.seconds = String(seconds).padStart(2, '0');
    dateComponents.accessibleTimerText = `${days} ${data.daysLabel}, ${hours} ${data.hoursLabel}, ${minutes} ${data.minutesLabel}, ${seconds} ${data.secondsLabel}`;
    // States as true until other conditions change to timeout
    dateComponents.open = true;
  };

  let dateComponentsInterval;
  const clearDateComponentsInterval = () => {
    /* if less than 1 second hide bar this works */
    /* I am forcing this to stay closed is if under a second to hide the countdown ribbon bar */
    dateComponents.open = false;
    document.querySelector('.countdown-ribbon-timmer').style.display = 'none';

    if (!dateComponentsInterval) {
      return;
    }

    clearInterval(dateComponentsInterval);
    dateComponentsInterval = null;
  };

  // update date components every second
  updateReactiveDateComponents();
  dateComponentsInterval = setInterval(() => {
    updateReactiveDateComponents(clearDateComponentsInterval);
  }, 1000);
}

window.countdownTimerRibbon.alpineData.initializedPromise.then(() => init());
